// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qI3C","title":"styles_title__3pgH0"};